/* Cabinet d'Orient — révélation au défilement (progressive enhancement) */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    var cards = Array.prototype.slice.call(main.querySelectorAll("[class*='product-card']"));
    var targets = [];

    sections.forEach(function (s, i) {
      if (i === 0) return; // le hero reste visible immédiatement
      s.classList.add('co-reveal');
      targets.push(s);
    });

    cards.forEach(function (c, i) {
      c.classList.add('co-reveal');
      c.style.setProperty('--co-delay', ((i % 4) * 80) + 'ms');
      targets.push(c);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('co-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (t) { io.observe(t); });

    // Sécurité : tout ce qui n'a pas été révélé apparaît après 4 s
    setTimeout(function () {
      targets.forEach(function (t) { t.classList.add('co-in'); });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
